export const Language = {
  en: 'English',
  nl: 'Dutch',
  iw: 'Hebrew',
  jp: 'Japanese',
  pt: 'Portuguese',
  fr: 'French',
  el: 'Greek',
  it: 'Italian',
  cmn: 'Mandarin',
  es: 'Spanish',
  de: 'German',
  mx: 'Mexican',
  us: 'American',
  dk: 'Danish',
  br: 'Brazilian',
  ch: 'Swiss',
  fi: 'Finnish',
  my: 'Malay',
  no: 'Norwegian',
  pl: 'Polish',
  ru: 'Russian',
  se: 'Swedish',
  th: 'Thai',
  vn: 'Vietnamese',
  ko: 'Korean',
  fil: 'Filipino',
  id: 'Bahasa Indonesia',
  hi: 'Hindi',
  km: 'Khmer',
  ca: 'Catalan',
  cs: 'Czech',
  ee: 'Estonian',
  lt: 'Lithuanian',
  lv: 'Latvian',
  sa: 'Arabic',
  ar: 'Argentinian',
  cl: 'Chilean',
  tr: 'Turkish',
  'es-ma': 'Malaga',
  'es-vl': 'Valencian',
};

export const Languages = Object.keys(Language);
